<template>
    <div>
        <el-row>
            <el-input v-model="search" placeholder="搜索" style="width:30%;"></el-input>
        </el-row>
        <el-table ref="dataTable"
            :max-height="!checkeds ? null : '400px'"
            :data="filterDataTable"
            row-key="insId"
            @selection-change="selectionChange">
            <el-table-column v-if="checkeds"
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column align="center" prop="name" label="项目名称"></el-table-column>
            <el-table-column label="访问地址">
                <template v-slot="{row}">
                    <div v-if="row.innerUrl">
                        内网地址：<a :href="row.innerUrl" target="_blank">{{row.innerUrl}}</a>
                    </div>
                    <div v-if="row.wanUrl">
                        外网地址：<a :href="row.wanUrl" target="_blank">{{row.wanUrl}}</a>
                    </div>
                    <div v-if="row.healthUrl">
                        健康检查：<a :href="row.healthUrl" target="_blank">{{row.healthUrl}}</a>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import { Loading } from "element-ui";
export default {
    props: {
        // 默认勾选的数据
        checkeds: {
            type: Array
        }
    },
    data: vm=>({
        listData: [],
        search: '',
        insIds: [], //勾选的实例
    }),
    created(){
        this.getDatas()
    },
    computed: {
        filterDataTable(){
            if(this.search){
                return this.filterArr(this.search, this.listData)
            }else{
                return this.listData
            }
        }
    },
    methods: {
        // 勾选默认数据
        checkRow(){
            const _this = this
            this.checkeds.forEach(checkedId => {
                const row = _this.listData.filter(data => data.insId == checkedId)[0]
                setTimeout(()=>{
                    _this.$refs.dataTable.toggleRowSelection(row, true)
                }, 50)
            })
        },
        // 勾选的数据
        selectionChange(selection){
            let arr = []
            selection.forEach(select => {
                arr.push(select.insId)
            })
            this.insIds = arr
            this.$emit('insIdsCallback', arr)
        },
        getDatas(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.listData = [];
            const url = this.baseUrl3 + 'analyses/get/show/list'
            this.$axios.get( url )
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.listData = data.urls
                        if(this.checkeds){
                            this.checkRow()
                        }

                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(err => {
                    console.log(err)
                    loading.close();
                });
        },
    }
}
</script>
